import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { createCounterpartiesInvoice } from "../../../../store/slices/counterpartySlice";
import {
  handleCounterCheckboxData,
  cancelItemCheckboxData,
  checkboxForDetailsOrDelete,
  setCheckboxData,
  onChangeCheckboxData,
} from "../../../../store/slices/tableSlice";
import {
  setCheckedDiscount,
  getSettingByType,
} from "../../../../store/slices/settingSlice";
import AddCounterpartyButton from "../../counterparty/components/AddCounterpartyButton";
import ApplicationCatalogue from "../../../../useHook/useTable/components/applicationCatalogue/ApplicationCatalogue";
import UseDropDown from "../../../../useHook/dropDown/UseDropDown";
import button_back from "../../../../style/img/button_back.png";

import "./purchase.css";
const PurchaseCreate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const checkedRow = useSelector((state) => state.table.checkboxData);
  const checkedCounterparty = useSelector(
    (state) => state.table.checkboxForDetailsOrDelete
  )[0];

  // discount
  const discounts = useSelector((state) => state.setting.data);

  const CheckedDiscount = useSelector((state) => state.setting.checkedDiscount);
  const handleDiscount = (item) => {
    dispatch(setCheckedDiscount(item));
  };

  const productsData = checkedRow
    ? checkedRow.map(({ price_sum, price, quantity_application, ...rest }) => ({
        price_sum:
          price_sum +
          (quantity_application * price * CheckedDiscount?.value) / 100,
        price,
        quantity_application,
        ...rest,
      }))
    : [];
  useEffect(() => {
    dispatch(getSettingByType({ type: "discount" }));
  }, []);

  const toggleRedaxData = (accessor, id) => {
    dispatch(handleCounterCheckboxData(accessor, id));
  };
  const onChangeApplicationQuantityRedaxData = ({ value, id }) => {
    dispatch(onChangeCheckboxData({ value, id }));
  };
  const cancelItemRedaxData = (id) => {
    dispatch(cancelItemCheckboxData(id));
  };
  // useEffect(() => {
  //   if (checkedCounterparty && checkedCounterparty.type !== "provider") {
  //     dispatch(checkboxForDetailsOrDelete([]));
  //   }
  // }, []);
  return (
    <div className="purchaseCreate">
      <div className="purchaseCreate_head">
        <img
          onClick={() => navigate("/purchase")}
          src={button_back}
          alt="back"
        />
        <span>Заявка</span>
      </div>
      <Formik
        initialValues={{ comment: "" }}
        validationSchema={Yup.object({
          // password: Yup.string().required("Enter password!"),
          // login: Yup.string().required("Enter login!"),
        })}
        onSubmit={async (body) => {
          const data = body;
          data.items = checkedRow.map(({ id, quantity_application }) => ({
            id,
            quantity: quantity_application,
          }));
          data.counterparty_id = checkedCounterparty?.id;
          data.discount_value = CheckedDiscount ? CheckedDiscount.value : 0;
          data.type = "request";

          const req = await dispatch(createCounterpartiesInvoice(data));

          if (req.payload === 200) {
            dispatch(setCheckboxData([]));
            dispatch(checkboxForDetailsOrDelete([]));
            navigate("/purchase");
          }
        }}
      >
        <Form className="">
          <div className="catalogueCreate_input_top_wrapper">
            <div className="catalogueCreate_input_top">
              <div className="catalogueCreate_input_top_first">
                <AddCounterpartyButton
                  checkedCounterparty={checkedCounterparty}
                  title={"Постачальники"}
                  navigateTo={"/purchase/create/search"}
                />
                <div>
                  <span>Тип цін</span>
                  <UseDropDown
                    selectedItem={CheckedDiscount}
                    handleChange={handleDiscount}
                    data={discounts}
                  />
                </div>

                {/* <ErrorMessage name="login" className="error " component="div" /> */}
              </div>
            </div>
            <div className="catalogueCreate_input_top_textarea">
              <span>Коментар</span>
              <Field as="textarea" type="text" name="comment" />
            </div>
          </div>
          <ApplicationCatalogue
            handleCounterApplication={toggleRedaxData}
            onChangeApplicationQuantity={onChangeApplicationQuantityRedaxData}
            cancelItemTableFunc={cancelItemRedaxData}
            checkedRow={productsData}
            setcheckedRow={() => {}}
            styleTable={{
              minHeight: "calc(100vh - 400px)",
              maxHeight: "calc(100vh - 400px)",
              padding: "0",
            }}
            button={false}
          />
          <div className="purchaseCreate_buttonWrapper">
            <button className="catalogueCreate_submit" type="submit">
              Додати
            </button>
            <button
              onClick={() => navigate("/purchase/create/catalouge")}
              className="catalogueCreate_submit"
            >
              За каталогом
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default PurchaseCreate;
